import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import ImperialTobaccoLightLogo from '../../assets/img/IB_United_Kingdom_Logo.png';
import ImperialTobaccoDarkLogo from '../../assets/img/IB.png';

import './footer.css';

const Footer = (props) => {
  const {
    links,
    optedInToPpc,
    ppcManagementUrl,
    hasGoldTheme,
    hasSelectTheme
  } = props;
  let logo = ImperialTobaccoLightLogo;

  if (hasGoldTheme || hasSelectTheme) {
    logo = ImperialTobaccoDarkLogo;
  }

  return (
    <footer className="user-footer">
      <div className="user-footer-container">
        <img src={logo} alt='Imperial Brands' />
        <div className="links">
          {links.map(link => (
            ((link.title === 'Ignite Mastercard Management' && optedInToPpc) || link.title !== 'Ignite Mastercard Management') && (
              <Link
                key={link.title}
                to={link.title === 'Ignite Mastercard Management' ? ppcManagementUrl : link.href}
                target={link.target}
              >
                {link.title}
              </Link>
            )
          ))}
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = state => ({
  optedInToPpc: state.viewConfig.profile.attributes['opted-in-to-ppc'],
  ppcManagementUrl: state.ppc.ppcManagementUrl,
  hasGoldTheme: state.viewConfig.profile.attributes['has-ignite-gold-outlet'],
  hasSelectTheme: state.viewConfig.profile.attributes['has-mini-chain-outlet']
});

export default connect(mapStateToProps)(Footer);
